// extracted by mini-css-extract-plugin
export var saListSection = "saList-module--saListSection--3F9pn";
export var saUl = "saList-module--saUl--cb7rs";
export var saItemText = "saList-module--saItemText--2OdgF";
export var saBlocks = "saList-module--saBlocks--3_N8L";
export var saTitleContainer = "saList-module--saTitleContainer--3sy4B";
export var saSubtitleContainer = "saList-module--saSubtitleContainer--15YdP";